import * as React from 'react';
import { Collapse, IconButton,  Table, TableBody, TableCell, TableContainer,  TableHead, TableRow, Paper, Typography} from '@mui/material';
import {KeyboardArrowDown, KeyboardArrowUp} from '@mui/icons-material';
import CompteHistory from './compte-history';

function Row(props) {
  const { row, table, start_date, end_date } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </IconButton>
        </TableCell>
        {table.map((col, index)=> col.row(row, index))}
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={table.length+1}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <CompteHistory start_date={start_date} end_date={end_date} compte={row} />
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}


export default function CollapsibleTable(props) {
  return (
    <TableContainer component={Paper}>
      <Table aria-label="collapsible table">
        <TableHead>
          <TableRow>
            <TableCell />
            { props.table.map((col, index)=>
              <TableCell key={index} align={col.header_align}>{col.header}</TableCell>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {props.data.map((row) => (
            <Row key={row._id} row={row} table={props.table} start_date={props.start_date} end_date={props.end_date} />
          ))}
        </TableBody>
        {typeof props.total==='number'? <TableBody>
          <TableRow>
            <TableCell rowSpan={3} colSpan={2} />
            <TableCell align="center" sx={{fontWeight:'bold', fontSize:16}}>Total hors petite caisse</TableCell>
            <TableCell align="right" sx={{fontWeight:'bold', fontSize:16}}>{(props.total-props.petite_caisse).toFixed(2)}€</TableCell>
          </TableRow>
          <TableRow>
            <TableCell align='center' sx={{backgroundColor:"white", fontWeight:'bold', fontSize:16}}>Petite Caisse</TableCell>
            <TableCell sx={{backgroundColor:"white", fontWeight:'bold', fontSize:16}} align="right">{props.petite_caisse}€</TableCell>
          </TableRow>
          <TableRow>
            <TableCell align='center' sx={{fontWeight:'bold', fontSize:16}}>Solde</TableCell>
            <TableCell align="right" sx={{fontWeight:'bold', fontSize:16}}>{props.total.toFixed(2)}€</TableCell>
          </TableRow>
        </TableBody> : null}
      </Table>
    </TableContainer>
  );
}